module.exports = __webpack_public_path__ + "img/空压机系统的节能优化系统.16ac18a3.png";